import styled from "styled-components/macro";
import { Flex } from "../Common.Styled";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const MainCont = styled.div`
  width: 100%;
  @media (max-width: 769px) {
    width: 100%;
  }
`;
export const MainConts = styled.div`
  width: 100%;
  @media (max-width: 1319px) {
  }
`;

export const Card = styled.div`
  width: 100%;
  cursor: pointer;
  border: 1px solid #dadada;
  border-radius: 4px;

  &:hover {
    box-shadow: 0 0 10px -3px #0007;
  }
`;

export const CardImgWrp = styled.div`
  position: relative;
  padding-top: 56.25%;
  border-radius: 4px 4px 0 0;

  img {
    position: absolute;
    top: 0;
    border-radius: 4px 4px 0 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardSaveBtn = styled.button`
  position: absolute;
  top: 1em;
  right: ${defaultLanguage === "ar" ? "" : "1em"};
  left: ${defaultLanguage === "ar" ? "1em" : ""};
  width: 2em;
  height: 2em;
  opacity: 0.8;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px 1px #000a;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &.property-saved {
    opacity: 1;
    background-color: #fff;
    color: #15396d;
  }
`;

export const DistLabel = styled.div`
  position: absolute;
  bottom: 1em;
  right: 1em;
  padding: 0.5em;
  background: #000a;
  border-radius: 0.25em;
  color: #fff;
  font-size: 0.7em;
`;

export const CardTxtWrp = styled.div`
  padding: 1em;
  @media (max-width: 367px) {
    padding: 0.6em;
  }
`;

export const PropStatus = styled((props) => <Flex ai="c" {...props} />)`
  color: #15396d;
  font-size: 0.7em;

  &::before {
    content: "";
    width: 1em;
    height: 1em;
    margin-right: ${defaultLanguage === "ar" ? "0" : "0.5em"};
    margin-left: ${defaultLanguage === "ar" ? "0.5em" : "0"};
    border-radius: 100%;
  }

  &.prop-status-active {
    &::before {
      /* background-color: red; */
      background-color: ${({ IsColoured }) =>
        IsColoured
          ? IsColoured === "1"
            ? `green`
            : IsColoured === "2"
            ? `blue`
            : IsColoured === "3"
            ? `red`
            : IsColoured === "4"
            ? `yellow`
            : IsColoured === "5"
            ? `orange`
            : "yellow"
          : `black`};
    }
  }
  @media (max-width: 1310px) {
    font-size: 1rem;
  }
  @media (max-width: 1110px) {
    font-size: 0.7rem;
  }
`;

export const PropTopDets = styled.span`
  color: #999999;
  font-size: 0.7em;
  font-family: "Montserrat";
  margin-left: 0.6rem;
  @media (max-width: 1310px) {
    font-size: 0.9rem;
  }
  @media (max-width: 1110px) {
    font-size: 0.7rem;
  }
  @media (max-width: 669px) {
    font-size: 0.6rem;
  }
  @media (max-width: 602px) {
    font-size: 0.7rem;
  }
  @media (max-width: 340px) {
    font-size: 0.6rem;
  }
`;

export const PropName = styled.span`
  font-weight: 500;
  font-family: "Montserrat";
  text-transform: capitalize;
  font-size: 0.9rem;
  @media (max-width: 1310px) {
    font-size: 1rem;
  }
  @media (max-width: 1110px) {
    font-size: 0.9rem;
  }
  @media (max-width: 669px) {
    font-size: 0.8rem;
  }
`;

export const PropPrice = styled.span`
  color: #06c972;
  font-weight: 500;
  font-family: "Montserrat";
  font-size: 0.9rem;
  @media (max-width: 1310px) {
    font-size: 1rem;
  }
  @media (max-width: 1110px) {
    font-size: 0.9rem;
  }
  @media (max-width: 669px) {
    font-size: 0.8rem;
  }
`;
export const PropertyBox = styled.div`
  width: 100%;
  /* background-color: aqua; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
  @media (max-width: 1310px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 602px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PropertyNotFound = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

export const PropertyBoxs = styled.div`
  width: 100%;
  /* background-color: aqua; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  @media (max-width: 1310px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  @media (max-width: 950px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
`;

export const CardShareBtn = styled.button`
  position: absolute;
  top: 1em;
  /* right: ${defaultLanguage === "ar" ? "" : "1em"}; */
  left: ${defaultLanguage === "ar" ? "1em" : "em"};
  width: 2em;
  height: 2em;
  opacity: 0.8;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &.property-saved {
    opacity: 1;
    background-color: #fff;
    color: #15396d;
  }
`;
